<template>
  <div>
    <div>
      <v-layout row>
        <v-flex xs9>
          <h3 :style="titleStyle">{{ $t('address') }}</h3>
        </v-flex>
        <v-flex
          xs3
          text-xs-right
        >
          <div
            v-if="editable"
            class="mr-3"
            style="margin-top: -5px;"
          >
            <v-btn
              icon
              small
              @click="openDialog"
            >
              <span class="mr-1" :style="changeStyle">{{ $t('change') }}</span>
              <v-icon
                small
                :color="theme.trashcan_color"
              >fas fa-edit</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div
      v-if="addressNotEmpty"
      class="ml-2 mb-3"
    >
      <span :style="addressStyle">{{ addressString }}</span>
    </div>
    <div v-else class="ml-2 mb-3">
      <span :style="addressStyle" class="font-italic">{{ $t('enter_address') }}</span>
    </div>
    <div class="ml-2 mb-3" v-if="user">
      <ul :style="listStyle">
        <li>{{ $t('receiver') }}: {{ address.contact_name ? address.contact_name : user.name + ' ' + user.name2}}</li>
<!--        <li>{{ $t('receiver_contact') }}: {{ address.contact_no ? '+65 ' + address.contact_no : '+' + user.country_code + ' ' + user.mobile }}</li>-->
        <li>{{ $t('receiver_contact') }}: {{ address.contact_no ? '+65 ' + address.contact_no : (/^$|^[6|8|9|3].{7}$/.test(user.mobile) ? '+65 ' + user.mobile : '+' + user.country_code + ' ' + user.mobile) }}</li>
      </ul>
    </div>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
    >
      <v-card :color="theme.login_bg_color">
        <v-card-text class="pa-4">
          <v-layout row>
            <v-flex
              xs12
              sm10
              offset-sm1
              md8
              offset-md2
              lg6
              offset-lg3
              xl6
              offset-xl3
            >
              <v-layout
                row
                align-center
              >
                <v-flex xs6>
                  <span class="main-title">{{ $t('delivery_address') }}</span>
                </v-flex>
                <v-flex
                  xs6
                  text-xs-right
                >
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="pa-0 ma-0"
                        v-if="hasUserAddress"
                        flat
                        :style="myAddressTitleStyle"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ $t('saved_address') }}
                      </v-btn>
                    </template>
                    <v-list>
                      <div
                        v-for="(userAddress, index) in addresses"
                        :key="userAddress.id"
                      >
                        <address-card :user-address="userAddress" @select-address="selectAddress(userAddress)" />
                        <v-divider v-if="index < addresses.length - 1"></v-divider>
                      </div>
                    </v-list>
                  </v-menu>
                </v-flex>
              </v-layout>
              <div
                v-if="addressMsg"
                class="mt-2 mb-2"
              >
                <span style="color: red">{{ addressMsg }}</span>
              </div>
              <div v-if="!otherAddress">
                <div class="mt-3 mb-0">
                  <v-text-field
                    v-model="inputAddress.postal_code"
                    outline
                    ref="postalCodeField"
                    name="postalCode"
                    label="Postal code"
                    @keyup="checkAddress"
                    hide-details
                  ></v-text-field>
                  <v-text-field
                    v-model="inputAddress.block_no"
                    outline
                    :style="inputAddressStyle"
                    clearable
                    ref="blockNoField"
                    name="blockNo"
                    label="Block no."
                    hide-details
                  ></v-text-field>
                  <v-text-field
                    v-model="inputAddress.road_name"
                    outline
                    :style="inputAddressStyle"
                    clearable
                    ref="roadNameField"
                    name="roadName"
                    label="Road name"
                    hide-details
                  ></v-text-field>
                  <v-text-field
                    v-model="inputAddress.building"
                    outline
                    :style="inputAddressStyle"
                    clearable
                    ref="buildingField"
                    name="building"
                    label="Building (optional)"
                    hide-details
                  ></v-text-field>
                  <v-text-field
                    v-model="inputAddress.floor_unit"
                    outline
                    :style="inputAddressStyle"
                    clearable
                    ref="floorUnitField"
                    name="floorUnit"
                    label="Floor unit"
                    :error-messages="!inputAddress.floor_unit || inputAddress.floor_unit.length === 0 ? 'Fill in your floor unit' : ''"
                    hide-details
                  ></v-text-field>
                  <v-text-field
                    v-if="user"
                    v-model="inputAddress.contact_name"
                    outline
                    :style="inputAddressStyle"
                    clearable
                    ref="contactNameField"
                    name="contact_name"
                    label="Recipient Name (optional)"
                    hide-details
                  ></v-text-field>
                  <v-text-field
                    v-if="user"
                    v-model="inputAddress.contact_no"
                    outline
                    :style="inputAddressStyle"
                    clearable
                    ref="contactNoField"
                    name="contact_no"
                    label="Contact No. (optional)"
                    type="number"
                    maxlength="8"
                    :rules="inputAddress.contact_no ? [phoneRules.pattern] : []"
                    hide-details
                    @keyup="checkContact"
                  >
                    <v-card-text
                      slot="prepend-inner"
                      style="padding: 14px 0 0 0"
                    >
                      +65
                    </v-card-text>
                  </v-text-field>
                </div>
                <div class="text-xs-center pt-3" v-if="canAddAddress">
                  <v-checkbox
                    v-model="saveAddress"
                    class="mt-0 pt-0"
                    label="Save address"
                  >
                  </v-checkbox>
                </div>
                <div class="text-xs-center">
                  <v-btn
                    :dark="enableBtn && enableBtnOfContactNo"
                    :color="theme.btn_color_secondary"
                    @click="confirmAddress"
                    :disabled="!(enableBtn && enableBtnOfContactNo)"
                  >
                    {{ $t('save') }}
                  </v-btn>
                  <v-btn
                    flat
                    :color="theme.btn_color_secondary"
                    @click="closeAddress"
                  >
                    {{ $t('close') }}
                  </v-btn>
                </div>
              </div>
              <div
                v-else
                class="mt-1"
              >
                <div
                  v-for="(userAddress, index) in addresses"
                  :key="userAddress.id"
                >
                  <address-card :user-address="userAddress" @select-address="selectAddress(userAddress)" />
                  <v-divider v-if="index < addresses.length - 1"></v-divider>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-divider class="mt-2 mb-2" :color="theme.orders_divider_color" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddressCard from '~/components/AddressCard'

export default {
  components: {
    'address-card': AddressCard,
  },
  data () {
    return {
      dialog: false,
      otherAddress: false,
      enableBtn: true,
      enableBtnOfContactNo: true,
      inputAddress: {
        title: '',
        postal_code: '',
        floor_unit: '',
        block_no: '',
        road_name: '',
        building: '',
        country: 'SINGAPORE',
        contact_name: '',
        contact_no: ''
      },
      phoneRules: {
        pattern: value => {
          const pattern = /^$|^[8,9,3].{7}$/
          return pattern.test(value) || 'Invalid phone number.'
        },
      },
      saveAddress: false
    }
  },
  props: {
    editable: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    ...mapGetters('auth', [
      'user', 'addresses'
    ]),
    ...mapGetters('config', [
      'theme'
    ]),
    ...mapGetters('delivery', [
      'address', 'isDeliverable', 'deliveryInfo', 'addressString'
    ]),
    changeStyle () {
      return {
        color: this.theme.trashcan_color
      }
    },
    titleStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    addressStyle () {
      return {
        color: this.theme.cart_name2_color
      }
    },
    inputAddressStyle () {
      return {
        marginTop: '10px',
        color: this.theme.cart_name_color,
      }
    },
    myAddressTitleStyle () {
      return {
        fontSize: '12px',
        color: this.theme.btn_color_secondary
      }
    },
    addressNotEmpty () {
      let addressNotEmpty = false
      Object.keys(this.inputAddress).forEach(key => {
        if (key != 'country' && this.inputAddress[key] && this.inputAddress[key] !== '') {
          addressNotEmpty = true
        }
      })
      return addressNotEmpty
    },
    addressMsg () {
      return !this.isDeliverable ? (this.deliveryInfo.msg ? this.deliveryInfo.msg : this.$t('postal_code_not_ready')) : ''
    },
    hasUserAddress () {
      return this.user && this.addresses && this.addresses.length > 0
    },
    listStyle () {
      return {
        listStyleType: 'none',
        paddingLeft: '0',
        color: this.theme.cart_name2_color
      }
    },
    canAddAddress () {
      return this.addresses.length < 5 && this.user
    },
    timerTextStyle () {
      return {
        color: this.theme.address_text_color
      }
    },
  },
  methods: {
    fullAddress (address) {
      return (address.block_no ? address.block_no + ' ' : '')
        + (address.road_name ? address.road_name + ' ' : '')
        + (address.building ? address.building + ' ' : '')
        + (address.floor_unit && address.floor_unit !== '-' ? address.floor_unit + ' ' : '')
        + (address.postal_code ? address.postal_code + ' ' : '')
        + (address.country ? address.country : '')
    },
    async openDialog () {
      // Refetch if model changed the value
      if (!this.deliveryInfo.location || (this.deliveryInfo.location && (this.deliveryInfo.location.postal_code !== this.inputAddress.postal_code))) {
        await this.$store.dispatch('delivery/fetchDeliveryInfo', this.inputAddress.postal_code)
      }
      this.dialog = true
    },
    async checkAddress () {
      if (this.inputAddress.postal_code.length === 6) {
        await this.$store.dispatch('delivery/fetchDeliveryInfo', this.inputAddress.postal_code)
      } else {
        this.$store.dispatch('delivery/resetDeliveryInfo')
      }
      if (!this.isDeliverable) {
        this.enableBtn = false
      } else {
        this.enableBtn = true
        const location = this.deliveryInfo.location
        this.inputAddress.block_no = location.block_no ? location.block_no : ''
        this.inputAddress.road_name = location.road_name ? location.road_name : ''
        this.inputAddress.building = location.building ? location.building : ''
      }
    },
    async checkContact () {
      console.log(this.inputAddress.contact_no)
      if (this.inputAddress.contact_no && !/^$|^[6|8|9|3].{7}$/.test(this.inputAddress.contact_no)) {
        this.enableBtnOfContactNo = false
      } else {
        this.enableBtnOfContactNo = true
      }
      console.log(this.enableBtnOfContactNo)
    },
    confirmAddress () {
      this.dialog = false
      if (!this.inputAddress.floor_unit) {
        this.inputAddress.floor_unit = '-'
      }
      if (this.saveAddress)
        this.$store.dispatch('auth/addAddress', this.inputAddress)
      this.$store.dispatch('delivery/setAddress', this.inputAddress)
    },
    closeAddress () {
      this.dialog = false
      this.inputAddress = { ...this.address }
    },
    async changeTab () {
      this.otherAddress = !this.otherAddress
      // Refetch after select
      if (!this.otherAddress) {
        await this.$store.dispatch('delivery/fetchDeliveryInfo', this.inputAddress.postal_code)
      }
    },
    selectAddress (address) {
      if (this.isDeliverable) {
        this.inputAddress = address
        this.$store.dispatch('delivery/setAddress', address)
      }
    }
  },
  beforeMount () {
    const vm = this
    this.$bus.$on('showAddressSelector', (payload) => { vm.dialog = payload })
  },
  mounted () {
    this.inputAddress = { ...this.address }
  },
  beforeDestroy () {
    this.$bus.$off('showAddressSelector')
  }
}
</script>

<style scoped>
.main-title {
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// src/components/AddressSelector.vue